import React, { Component } from 'react/lib/React';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Card, CardActions, CardTitle } from 'material-ui/Card';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import Snackbar from 'material-ui/Snackbar';
import {  debounce, get, isEmpty, startCase, template, toLower } from 'lodash';
import { BUTTON_COLOR, BACKGROUND_COLOR } from '../constants/colours'
import {LOAN_TYPES} from '../constants/common'
import createLead, { getPincodeDetails } from '../actions/lead';
import { sendOTP, verifyOTP } from '../actions/authentication';
import language from '../constants/languages'
import { MenuItem } from 'material-ui/Menu';
import { SelectField } from 'material-ui';

const styles = {
  flexDiv: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center',
	  marginTop: "8%",
    marginLeft: "25%",
    marginRight: "25%",
	  paddingBottom: 20,
	  marginBottom: "5%",
  },
  floatingLabelStyle: {
    color: '#31a7ef'
  },
};

class Apply extends Component {
  state = {
    name: '',
    amount: '',
    mobile: '',
    area: '',
    disabled: false,
    snackOpen: false,
    submitted: false,
    nameError: '',
    mobileError: '',
    areaError: '',
    amountError: '',
    otpError: '',
    otpResend: 60,
    firstOTPSent: false,
    otpVerified: false,
    city : '',
    cityError : '',
    state : '',
    stateError : '',
    pincode : '',
    pincodeError : '',
    loanType : '',
    loanTypeError : '',
    addressDisable : false
  }

  async componentWillUnmount() {
    await clearInterval(this.timer);
  }

  onSubmit = async (e) => {
    e.preventDefault();
    const result = await this.props.getPincodeDetails(305922)
    if (await this.validate()) {
      const body = {
        name: startCase(toLower(this.state.name)),
        mobile: this.state.mobile,
        amount: this.state.amount,
        area: this.state.area,
        lead_type : this.state.loanType,
        pincode : this.state.pincode,
        city_state : this.state.state,
        city : this.state.city
      };
      this.setState({ disabled: true });
      const res = await this.props.createLead(body);
      if (!isEmpty(get(res, 'payload.data', {}))) {
        this.setState({ snackOpen: true, submitted: true });
      } else {
        this.setState({ disabled: false });
        alert('Something Went Wrong.');
      }
    }
  }

  onHandleRequestClose = () => {
    this.setState({
      snackOpen: false,
    });
    this.props.history.push('/');
  };


  findPincodeDetails = debounce(async () => {
    const result = await this.props.getPincodeDetails(this.state.pincode);
    const data = get(result, 'payload.data', {})
    if (!isEmpty(data)) {
      this.setState({state : data.state_name,city : data.district_name,addressDisable : true})
    }
    }, 300);

  
  onInputChange = async(e, key) => {
    if(key === 'pincode') {
      this.findPincodeDetails()
    }
    this.setState({
      [key]: e.target.value
    });
  }

  /*
   * Method is used to set timer for resend otp
   * */
  counterDown = () => {
    const timer = setInterval(() => {
      if (this.state.otpResend > 0) {
        this.setState({
          otpResend: this.state.otpResend - 1
        });
      } else {
        clearInterval(this.timer);
      }
    }, 1000); // One sec
    return timer;
  }

  verifyOTP = async () => {
    const body = {
      otp: this.state.otp,
    };
    const response = await this.props.verifyOTP(body);
    if (get(response.payload, 'success', false)) {
      this.setState({ otpVerified: true });
    } else {
      this.setState({ otpVerified: false });
      alert('OTP is wrong');
    }
  }

  validate = async () => {
    let validateFlag = true;
    if (this.state.name === '') {
      validateFlag = false;
      this.setState({
        nameError: 'Name is required.'
      });
    } else {
      this.setState({
        nameError: ''
      });
    }
    if (this.state.mobile === '') {
      validateFlag = false;
      this.setState({
        mobileError: 'Mobile is required.'
      });
    } else if (this.state.mobile.length > 10 || this.state.mobile.length < 10) {
      validateFlag = false;
      this.setState({
        mobileError: 'Mobile number should be 10 digits'
      });
    } else {
      this.setState({
        mobileError: ''
      });
    }
    if (this.state.area === '') {
      validateFlag = false;
      this.setState({
        areaError: 'Area of residence is required.'
      });
    } else {
      this.setState({
        areaError: ''
      });
    }
    if (this.state.amount === '') {
      validateFlag = false;
      this.setState({
        amountError: 'Loan amount is required.'
      });
    } else {
      this.setState({
        amountError: ''
      });
    }
    if(this.state.pincode === '') {
      validateFlag = false;
      this.setState({
        pincodeError: 'Pincode is required.'
      });
    } else {
      this.setState({
        pincodeError: ''
      });
    }
    if(this.state.state === '') {
      validateFlag = false;
      this.setState({
        stateError: 'State is required.'
      });
    } else {
      this.setState({
        stateError: ''
      });
    }
    if(isEmpty(this.state.city)) {
      validateFlag = false;
      this.setState({
        cityError: 'City is required.'
      });
    } else {
      this.setState({
        cityError: ''
      });
    }
    if(this.state.loanType === '') {
      validateFlag = false;
      this.setState({
        loanTypeError: 'Loan Type is required.'
      });
    } else {
      this.setState({
        loanTypeError: ''
      });
    }
    return validateFlag;
  }

  sendOTP = async () => {
    await clearInterval(this.timer);
    this.setState({
      otpResend: 60
    });
    this.timer = this.counterDown();
    this.setState({
      firstOTPSent: true
    });
    const body = {
      mobile: this.state.mobile,
    };
    this.props.sendOTP(body);
  }

  styles = {
    display: "grid",
    'grid-template-columns': 'repeat(3, 1fr)',
    gap: '10px'
  }

  flexStyle = {
      display :'flex',
      gap:'30px'
  }

  render() {
    const fieldStyle = {
      width: '100%',
      background: 'rgba(255,255,255,0.05)',
      border: '1px solid rgba(199,125,204,0.25)',
      borderRadius: 10,
      padding: '14px 16px',
      color: '#ffffff',
      fontSize: 15,
      outline: 'none',
      boxSizing: 'border-box',
    };
    const labelStyle = {
      display: 'block',
      color: '#b3b2c7',
      fontSize: 12,
      fontWeight: 600,
      textTransform: 'uppercase',
      letterSpacing: '0.6px',
      marginBottom: 6,
    };
    const errorStyle = {
      color: '#ff6b6b',
      fontSize: 12,
      marginTop: 4,
    };
    const groupStyle = {
      flex: 1,
      minWidth: 200,
    };
    const rowStyle = {
      display: 'flex',
      gap: 20,
      flexWrap: 'wrap',
      marginBottom: 20,
    };

    return (
      !isEmpty(this.props.selectedLanguage) && (
        <div style={{ minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '40px 16px' }}>
          <div style={{
            background: 'rgba(30,26,61,0.95)',
            border: '1px solid rgba(199,125,204,0.2)',
            borderRadius: 20,
            boxShadow: '0 20px 60px rgba(0,0,0,0.5)',
            padding: '40px 36px',
            width: '100%',
            maxWidth: 680,
          }}>
            <div style={{ textAlign: 'center', marginBottom: 32 }}>
              <h2 style={{ color: '#ffffff', fontWeight: 800, fontSize: 28, margin: 0 }}>Apply for a Loan</h2>
              <p style={{ color: '#b3b2c7', marginTop: 8, fontSize: 14 }}>Fill in your details and we'll get back to you</p>
            </div>

            <form onSubmit={e => this.onSubmit(e)}>
              <div style={rowStyle}>
                <div style={groupStyle}>
                  <label style={labelStyle}>Name</label>
                  <input style={fieldStyle} type="text" value={this.state.name} onChange={e => this.onInputChange(e, 'name')} placeholder="Your full name" />
                  {this.state.nameError && <div style={errorStyle}>{this.state.nameError}</div>}
                </div>
                <div style={groupStyle}>
                  <label style={labelStyle}>Mobile</label>
                  <input style={fieldStyle} type="number" value={this.state.mobile} onChange={e => this.onInputChange(e, 'mobile')} placeholder="10-digit mobile number" />
                  {this.state.mobileError && <div style={errorStyle}>{this.state.mobileError}</div>}
                </div>
              </div>

              <div style={rowStyle}>
                <div style={groupStyle}>
                  <label style={labelStyle}>Loan Type</label>
                  <select
                    style={{...fieldStyle, appearance: 'none', cursor: 'pointer'}}
                    value={this.state.loanType}
                    onChange={e => this.setState({ loanType: e.target.value })}
                  >
                    <option value="" style={{ background: '#1E1A3D' }}>Select loan type</option>
                    {Object.entries(LOAN_TYPES).map(([key, val]) => (
                      <option key={key} value={val} style={{ background: '#1E1A3D' }}>{val}</option>
                    ))}
                  </select>
                  {this.state.loanTypeError && <div style={errorStyle}>{this.state.loanTypeError}</div>}
                </div>
                <div style={groupStyle}>
                  <label style={labelStyle}>Loan Amount (₹)</label>
                  <input style={fieldStyle} type="number" value={this.state.amount} onChange={e => this.onInputChange(e, 'amount')} placeholder="Amount required" />
                  {this.state.amountError && <div style={errorStyle}>{this.state.amountError}</div>}
                </div>
              </div>

              <div style={rowStyle}>
                <div style={groupStyle}>
                  <label style={labelStyle}>Pincode</label>
                  <input style={fieldStyle} type="number" value={this.state.pincode} onChange={e => this.onInputChange(e, 'pincode')} placeholder="6-digit pincode" />
                  {this.state.pincodeError && <div style={errorStyle}>{this.state.pincodeError}</div>}
                </div>
                <div style={groupStyle}>
                  <label style={labelStyle}>City</label>
                  <input style={{...fieldStyle, opacity: this.state.addressDisable ? 0.6 : 1}} type="text" value={this.state.city} disabled={this.state.addressDisable} onChange={e => this.onInputChange(e, 'city')} placeholder="City" />
                  {this.state.cityError && <div style={errorStyle}>{this.state.cityError}</div>}
                </div>
              </div>

              <div style={rowStyle}>
                <div style={groupStyle}>
                  <label style={labelStyle}>State</label>
                  <input style={{...fieldStyle, opacity: this.state.addressDisable ? 0.6 : 1}} type="text" value={this.state.state} disabled={this.state.addressDisable} onChange={e => this.onInputChange(e, 'state')} placeholder="State" />
                  {this.state.stateError && <div style={errorStyle}>{this.state.stateError}</div>}
                </div>
                <div style={groupStyle}>
                  <label style={labelStyle}>Address</label>
                  <input style={fieldStyle} type="text" value={this.state.area} onChange={e => this.onInputChange(e, 'area')} placeholder="Area / Street" />
                  {this.state.areaError && <div style={errorStyle}>{this.state.areaError}</div>}
                </div>
              </div>

              {!this.state.submitted && (
                <button
                  type="submit"
                  disabled={this.state.disabled}
                  style={{
                    width: '100%',
                    padding: '15px',
                    background: this.state.disabled ? 'rgba(146,90,148,0.4)' : 'linear-gradient(135deg, #925a94, #c77dcc)',
                    color: '#ffffff',
                    border: 'none',
                    borderRadius: 10,
                    fontSize: 16,
                    fontWeight: 700,
                    cursor: this.state.disabled ? 'not-allowed' : 'pointer',
                    letterSpacing: '0.5px',
                    marginTop: 8,
                    transition: 'opacity 0.2s ease',
                  }}
                >
                  Submit Application
                </button>
              )}

              {this.state.submitted && (
                <button
                  type="button"
                  onClick={() => this.props.history.push('/')}
                  style={{
                    width: '100%',
                    padding: '15px',
                    background: 'linear-gradient(135deg, #925a94, #c77dcc)',
                    color: '#ffffff',
                    border: 'none',
                    borderRadius: 10,
                    fontSize: 16,
                    fontWeight: 700,
                    cursor: 'pointer',
                    marginTop: 8,
                  }}
                >
                  {language[this.props.selectedLanguage].go_back}
                </button>
              )}
            </form>

            <Snackbar
              open={this.state.snackOpen}
              message="We have successfully received your request."
              autoHideDuration={4000}
              onRequestClose={this.onHandleRequestClose}
            />
          </div>
        </div>
      )
    );
  }
}

const mapStateToProps = (state) => ({
  selectedLanguage: state.defaultLanguage
});

const mapDispatchToProps = dispatch => ({
  createLead: body => dispatch(createLead(body)),
  sendOTP: body => dispatch(sendOTP(body)),
  verifyOTP: body => dispatch(verifyOTP(body)),
  getPincodeDetails : pinCode => dispatch(getPincodeDetails(pinCode))
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Apply));



// WEBPACK FOOTER //
// ./src/components/Apply.js